import EvidendeIndicator from "../../evidence/EvidenceIndicator";
import GhostInfoSection from "../GhostInfoSection";
import SanityIndicator from "../SanityIndicator";
import SpeedIndicator, { speedExactly, speedOr } from "../SpeedIndicator";
import SpeedSymbol from "../SpeedSymbol";

export default function Dayan() {
    return (
        <div>
            <div className="ghost-details">
                <GhostInfoSection title="Evidence">
                    <ul className="list-unstyled">
                        <li><EvidendeIndicator evidenceType="EMF 5" /></li>
                        <li><EvidendeIndicator evidenceType="Ghost Orbs" /></li>
                        <li><EvidendeIndicator evidenceType="Spirit Box" /></li>
                    </ul>
                </GhostInfoSection>
                <GhostInfoSection title="Gender">
                    The Dayan always has a female name and ghost model.
                </GhostInfoSection>
                <GhostInfoSection title="Hunt">
                    <ul>
                        <li>
                            When the players are outside of a 10 m range, the Dayan will behave like a normal ghost.
                        </li>
                        <li>
                            When the players are moving within 10 m, the Dayan may hunt at <DayanSanityIndicator which="fast" /> and
                            is fast at <DayanSpeedIndicator which="fast" />.
                        </li>
                        <li>
                            When the players are standing still within 10 m, the Dayan hunts at <DayanSanityIndicator which="slow" /> and
                            is slow at <DayanSpeedIndicator which="slow" />.
                        </li>
                    </ul>
                </GhostInfoSection>
            </div>
        </div>
    );
}

export function DayanSanityIndicator({ which }: { which?: 'slow' | 'fast' }) {
    return (
        <>
        {which !== 'fast' && <SanityIndicator sanity={45} tooltip="players stand still" />}
        {which !== 'slow' && <SanityIndicator sanity={65} tooltip="players are moving" />}
        </>
    );
}

export function DayanSpeedIndicator({ which }: { which?: 'slow' | 'fast' }) {
    const slow = speedExactly(1.2);
    const fast = speedExactly(2.25, .5);

    return (
        <>
        {which !== 'fast' && <SpeedSymbol speed={1.2} description="show when players stand still within 10m" speedingUp />}
        {which !== 'slow' && <SpeedSymbol speed={2.25} description="fast when players are moving within 10m" speedingUp />}
        <SpeedIndicator speed={speedOr(slow, fast)} />
        </>
    );
}